import React, { useEffect, useState } from 'react';
import { useRouteData } from 'react-static';
// services & helpers
import FrontendHttpService from '@nmx/utils-frontend/dist/services/FrontendHttpService';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Loading from '@nmx/template/dist/componentLibrary/components/Loading';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ScrollToAnchorCta from '../../../../components/scrollToAnchorCta';
// styles
import {
  ColStyled,
  TableStyled,
  TBodyStyled,
  TDStyled,
  THeadStyled,
  THStyled,
  TypographyStyledTableHeading,
  ULStyled,
} from '../../../_styles/styles';

export default () => {
  const [isLoading, setIsLoading] = useState(true);
  const [unipvals, setUnipvals] = useState({ models: [] });
  const { pageProps } = useRouteData();

  class MsFundsService {
    static getUnipvals() {
      return new Promise((resolve, reject) => {
        this.httpService.get('/unipvals.json')
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    }
  }

  MsFundsService.httpService = new FrontendHttpService({ baseURL: pageProps.msFundsBaseUrl });

  useEffect(() => {
    MsFundsService.getUnipvals()
      .catch(() => {
        console.error('An error occurred while fetching unipvals');
      })
      .then((data) => {
        setUnipvals(data);
        setIsLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (unipvals.models.length === 0 && isLoading) {
    return (
      <Row align='center'>
        <Col>
          <Loading />
        </Col>
      </Row>
    );
  }

  return (
    <SectionContainer
      id='daily-unit-values-income-annuities-unipvals'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding>
      <Row>
        <Col>
          <Typography
            component='h1'
            nextElement='link'>
            {unipvals.uvDate}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <ULStyled>
            {unipvals.models.map((unipval, unipvalsCodeIndex) => (
              <li key={`unipvals-list-item-${unipvalsCodeIndex + 1}`}>
                <ScrollToAnchorCta
                  id={`unipvals-${unipval.code}-${unipval.aircode}`}
                  targetId={`${unipval.code}-${unipval.aircode}`}
                  variant='primaryDeemphasize'>
                  {unipval.name}
                </ScrollToAnchorCta>
              </li>
            ))}
          </ULStyled>
        </Col>
      </Row>
      <Row>
        {unipvals.models.map((unipval, unipvalsIndex) => (
          <ColStyled
            id={`${unipval.code}-${unipval.aircode}`}
            key={`unipvals-col-${unipvalsIndex + 1}`}>
            <Typography
              component='h2'
              nextElement='typography'>
              {unipval.name}
              <Typography disableBottomPadding>
                Aircode: {unipval.aircode}
              </Typography>
              <Typography disableBottomPadding>
                {unipval.code}
              </Typography>
            </Typography>
            <TableStyled>
              <THeadStyled>
                <tr>
                  <th>
                    <TypographyStyledTableHeading themeType='darkTheme'>
                      Code
                    </TypographyStyledTableHeading>
                  </th>
                  <th>
                    <TypographyStyledTableHeading themeType='darkTheme'>
                      Name
                    </TypographyStyledTableHeading>
                  </th>
                  <th>
                    <TypographyStyledTableHeading themeType='darkTheme'>
                      Unit Value
                    </TypographyStyledTableHeading>
                  </th>
                  <th>
                    <TypographyStyledTableHeading themeType='darkTheme'>
                      Unit Value Change
                    </TypographyStyledTableHeading>
                  </th>
                  <th>
                    <TypographyStyledTableHeading themeType='darkTheme'>
                      Unit Value Per
                    </TypographyStyledTableHeading>
                  </th>
                </tr>
              </THeadStyled>
              <TBodyStyled>
                {unipval.funds.map((fund, unipvalsFundIndex) => (
                  <tr key={`unipvals-tr-${unipvalsFundIndex + 1}`}>
                    <TDStyled>{fund.code}</TDStyled>
                    <THStyled>{fund.name}</THStyled>
                    <TDStyled>{fund.unitValue}</TDStyled>
                    <TDStyled>{fund.unitValueChange}</TDStyled>
                    <TDStyled>{fund.unitValuePer}</TDStyled>
                  </tr>
                ))}
              </TBodyStyled>
            </TableStyled>
          </ColStyled>
        ))}
      </Row>
    </SectionContainer>
  );
};
